import { SERVICE_ACCOUNTS_PROTOCOLS_OPTIONS as PROTOCOLS } from '@silverfort-nodelibs/common/utils/consts';
import { Button, ButtonStyles, Checkbox, IconButton, Icons, Label } from '@silverfort/sf-components';
import { useState } from 'react';

const ProtocolPicker = ({ selectedProtocols = [], onSave, onClose }) => {
    const [protocols, setProtocols] = useState(new Set([...selectedProtocols]));

    return (
        <div className="w-full absolute top-0 left-[276px]">
            <div className={'bg-sf-white w-[272px] h-[208px] shadow-sf-medium border border-sf-gray-100 rounded-lg'}>
                <div className="flex border-b px-4 border-sf-gray-100 justify-between items-center h-14">
                    <Label text={'Select Protocols'} />
                    <IconButton onClick={() => onClose()} icon={Icons.Cancel} />
                </div>
                <div className="flex flex-col border-b py-4 px-6 gap-2 border-sf-gray-100 justify-center h-24">
                    {Object.values(PROTOCOLS).map((protocol, i) => {
                        return (
                            <div key={i} className="flex gap-2 items-center">
                                <Checkbox
                                    onChange={() => {
                                        const newProtocols = new Set([...protocols]);
                                        if (protocols.has(protocol)) {
                                            newProtocols.delete(protocol);
                                        } else {
                                            newProtocols.add(protocol);
                                        }
                                        setProtocols(newProtocols);
                                    }}
                                    checked={protocols.has(protocol)}
                                />
                                <Label text={protocol.label} />
                            </div>
                        );
                    })}
                </div>
                <div className="flex border-b px-4 gap-1 border-sf-gray-100 justify-end items-center h-14">
                    <Button text="Cancel" buttonStyle={ButtonStyles.Tertiary} onClick={() => onClose()} />
                    <Button
                        text="Save"
                        disabled={!protocols.size}
                        onClick={() => protocols.size && onSave([...protocols])}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProtocolPicker;
